// Timeout for initial avatar page navigation and rendering
export const AVATAR_PAGE_TIMEOUT = 60000;

// Timeout for avatar generation process
export const AVATAR_GENERATION_TIMEOUT = 30000;

// Delay before retrying avatar initialization
export const AVATAR_INITIALIZATION_RETRY_DELAY = 5000;

// Avatar rotation angles
export enum AvatarRotation {
  FRONT = 0,
  BACK = 180,
}
